import * as React from 'react';
export const CVSvg = React.forwardRef(function CVSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M0 8h16v3H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M15 11V8h1v3h-1ZM0 8h1v3H0V8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M1.994 2h12.012C15.106 2 16 2.896 16 4.001V8H0V4.001A2 2 0 0 1 1.994 2ZM0 11h16v1.5a1.5 1.5 0 0 1-1.505 1.5H1.505A1.498 1.498 0 0 1 0 12.5V11Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 9h16v1H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        fillRule: 'nonzero',
        d: 'M6.5 11a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0-2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-1 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-1-4.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-1-.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2-4a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-1 1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z',
      }),
    ),
  );
});
CVSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var CV = {
  category: 'flag',
  colorable: false,
  name: 'CV',
  svg: CVSvg,
};
